// src/core/common/modal/roomDetailModal.tsx
import React from "react";
import Slider from "react-slick";
import DOMPurify from "dompurify";
// import ImageWithBasePath from "../imageWithBasePath"; // optional - uncomment if you use it
interface Props {
  visible: boolean;
  onClose: () => void;
  room?: any | null;
  roomImages?: string[];
  hotelDetails?: any;
}

const RoomDetailModal: React.FC<Props> = ({ visible, onClose, room, roomImages = [], hotelDetails }) => {
  if (!visible) return null;

  const sliderSettings = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 400,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const imagesToShow = (roomImages && roomImages.length > 0) ? roomImages : (hotelDetails?.Images || []);

  return (
    <div className="room-detail-modal-overlay" role="dialog" aria-modal="true" aria-label="Room details">
      <div className="room-detail-modal" role="document">
        <div className="modal-header d-flex align-items-center justify-content-between">
          <h5 className="mb-0">
            {room ? (Array.isArray(room.Name) ? room.Name.join(", ") : room.Name) : "Room Details"}
          </h5>
          <button className="btn btn-link text-muted" onClick={onClose} aria-label="Close modal">
            ✕
          </button>
        </div>

        <div className="modal-body">
          <div style={{ marginBottom: 16 }}>
            <Slider {...sliderSettings}>
              {imagesToShow.map((img: string, idx: number) => (
                <div key={idx} className="service-img text-center">
                  <img
                    src={img}
                    alt={`room-img-${idx}`}
                    style={{ maxHeight: 360, objectFit: "cover", width: "100%", borderRadius: 8 }}
                  />
                </div>
              ))}
            </Slider>
          </div>

          <div className="d-flex justify-content-between align-items-start gap-3 mb-3">
            <div>
              <h6 className="mb-1">{room?.MealType || ""}</h6>
              <div className="small text-muted">{room?.Inclusion || ""}</div>
            </div>
            <div className="text-end">
              <div className="text-primary fw-bold fs-18">{room?.TotalFare?.toLocaleString() || ""}</div>
              <small className="text-muted">Total price</small>
            </div>
          </div>

          <div className="mb-3">
            <h6 className="mb-2">Cancellation Policy</h6>
            {room?.CancelPolicies?.length ? (
              <ul className="small">
                {room.CancelPolicies.map((p: any, i: number) => (
                  <li key={i}>
                    📅 {p.FromDate} → <strong>{p.ChargeType === "Percentage" ? `${p.CancellationCharge}%` : `${p.CancellationCharge}`}</strong>
                  </li>
                ))}
              </ul>
            ) : (
              <div className="small text-muted">No cancellation policies listed.</div>
            )}
          </div>

          <div className="mb-3">
            <h6 className="mb-2">Room Info</h6>
            <div
              className="small"
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(room?.Description || ""),
              }}
            />
          </div>

          <div className="mb-0 d-flex gap-2">
            <button className="btn btn-outline-secondary" onClick={onClose}>
              Close
            </button>
          </div>
        </div>
      </div>

      {/* Inline styles for immediate use — move to CSS file if you prefer */}
      <style>{`
        .room-detail-modal-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,0.45);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 2000;
          padding: 16px;
        }
        .room-detail-modal {
          width: 100%;
          max-width: 900px;
          background: #fff;
          border-radius: 10px;
          box-shadow: 0 8px 30px rgba(0,0,0,0.2);
          overflow: hidden;
        }
        .modal-header { padding: 16px; border-bottom: 1px solid #eee; display:flex; align-items:center; justify-content:space-between; }
        .modal-body { padding: 16px; max-height: 75vh; overflow-y: auto; }
        .service-img img { border-radius: 8px; }
      `}</style>
    </div>
  );
};

export default RoomDetailModal;
